import type { ChatTarget } from "@/app/libs/chatStart";

/**
 * Chat screen for a page or booking. It opens as a draft: the conversation is
 * only created (and a booking linked to it) when the first message is sent.
 */
export function newChatPath(targetType: ChatTarget, targetId: string): string {
  const params = new URLSearchParams({ targetType, targetId });
  return `/contact/new?${params.toString()}`;
}
